import { useMemo } from 'react';
import mergeWith from 'lodash.mergewith';
import { createHawkinsComponentBaseClassName, isString } from '../util';
import { useHawkinsContext } from './useHawkinsContext';
export function classesMergeFn(val1, val2) {
    if (isString(val1) && isString(val2)) {
        // Concatenate the CSS class strings instead of clobbering them.
        return [val1, val2].join(' ');
    }
    // Returning `undefined` causes the default merge behavior to be used.
    return undefined;
}
/**
 * A hook that allows for context-aware overriding of a component’s CSS classes.
 *
 * @private
 */
export function useClasses(componentName, baseClasses, userClasses) {
    var _a = useHawkinsContext(), _b = _a.defaultClasses, globalClasses = _b.GLOBAL, _c = componentName, hawkinsContextClasses = _b[_c];
    // The order of overrides is:
    //  - Hawkins-provided component classes
    //  - User-provided `HawkinsProvider` classes
    //  - User-provided `props.className` and `props.classes` classes
    return useMemo(function () {
        // These should be applied 100% of the time, regardless if there are overrides or not
        var hawkinsBaseClasses = {
            HAWKINS_BASE: "".concat(createHawkinsComponentBaseClassName(componentName), " ").concat(globalClasses !== null && globalClasses !== void 0 ? globalClasses : '').trim(),
        };
        // In most cases, there won't be any class overrides, so return the base classes to save time.
        if (!hawkinsContextClasses && !userClasses) {
            return mergeWith(hawkinsBaseClasses, baseClasses);
        }
        return mergeWith(
        // Lodash `mergeWith()` mutates its first argument, so start with a fresh object.
        hawkinsBaseClasses, baseClasses, hawkinsContextClasses, userClasses, classesMergeFn);
    }, [baseClasses, componentName, globalClasses, hawkinsContextClasses, userClasses]);
}
//# sourceMappingURL=useClasses.js.map